module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03d.91e1e3f5.jpg";